export default __webpack_public_path__ + "assets/jamaica-flag.png";